import type { ReactNode } from 'react';
import type { FeatureFlags } from '@noths/polaris-client-feature-flags';
import type { SiteChromeContent } from '@noths/polaris-client-site-chrome-ui';

export enum LayoutTypes {
  MINIMAL,
  CLIENT_SITE_CHROME_UI,
}

interface BaseLayoutComponentProps {
  children?: ReactNode;
  siteChromeContent?: SiteChromeContent;
}

export interface LayoutComponentProps extends BaseLayoutComponentProps {
  NODE_ENV: string;
}

export interface SiteChromeLayoutComponentProps extends BaseLayoutComponentProps {
  enableCurator?: boolean;
  featureFlags?: FeatureFlags;
  isProdLikeEnv: boolean;
  mergeBasket?: boolean;
  searchedTerm?: string;
  siteChromeCompactMode?: boolean;
  stickyTopBanner?: boolean;
}
